<template>
  <div v-if="modalIsOpened" class="fixed inset-0 w-full bg-black/30 z-50">
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
    >
      <div class="w-[100vw] max-w-[1000px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div class="mx-auto box-effect rounded-[10px] bg-white overflow-hidden">
          <div
            id="title"
            class="flex items-center justify-between py-[12px] pl-[20px] pr-[10px] bg-[#9B237B]"
          >
            <span class="PC_Body2-R text-[#FCFCFC]"> ประวัติ </span>
            <CloseIcon
              @click="closeModal"
              class="w-[24px] h-[24px] bg-white text-[#9B237B] rounded-full cursor-pointer"
            />
          </div>
          <div class="max-h-[642px] flex flex-col p-[20px] pt-[12px] gap-[10px] bg-[#FFF] overflow-auto">
            <div class="flex items-center gap-[10px] flex-wrap sm:flex-nowrap">
              <div class="w-full">
                <SearchBox
                  :placeholder="'ค้นหา ชื่อทรัพยากร, ชื่อผู้กระทำ'"
                  v-model="filter.search"
                  @update:modelValue="
                    () => {
                      (filter.page = ''), debouncedFetch();
                    }
                  "
                />
              </div>
              <!-- datePicker -->
              <DatePicker2
                :containerClass="'w-full sm:max-w-[257px]'"
                :modelValue="range"
                :placeholder="'เลือกช่วงเวลาที่กระทำ'"
                :isRange="true"
                @update:modelValue="(date) => selectRange(date)"
              />
              <!-- datePicker -->
            </div>
            <div>
              <!-- filter bar -->
              <div class="overflow-scroll">
                <div class="min-w-[620px] flex items-center gap-[4px]">
                  <div
                    v-for="row in allProductGroup"
                    :key="row.id"
                    class="filterBar"
                    :class="{
                      active: String(filter.group_id ?? '') === String(row.id),
                    }"
                    @click="
                      () => {
                        const isSame =
                          String(filter.group_id ?? '') === String(row.id);
                        if (!isSame) {
                          filter.group_id = row.id;
                          filter.page = '';
                          getData();
                        }
                      }
                    "
                  >
                    <span class="PC_Body2-R">{{ row.name }}</span>
                  </div>
                </div>
              </div>
              <!-- filter bar -->
              <!-- accordion list -->
              <div
                class="h-[465px] w-full flex flex-col items-start overflow-auto"
              >
                <div
                  v-for="(row, idx) in productRequestHistoryList"
                  :key="idx"
                  class="w-full"
                >
                  <div
                    class="w-full flex items-center justify-between gap-[14px] p-[8px] border border-[#DFDCDD]"
                  >
                    <div
                      class="w-full flex items-center justify-between gap-[10px] flex-wrap"
                    >
                      <div class="w-full flex items-center gap-[10px]">
                        <span class="bodyS max-w-[70%]">{{ row.name }}</span>
                        <span class="bodyS">
                          {{ row.unit_name ? `(${row.unit_name})` : "" }}
                        </span>
                      </div>
                      <div class="w-full sm:w-fit flex items-center gap-[14px]">
                        <span class="bodyS">
                          {{ row.amount }}
                        </span>
                        <div class="w-[1px] h-[14px] bg-[#B7B2B5]"></div>
                        <div class="flex items-center gap-[6px]">
                          <span class="bodyS">
                            {{ row.created_at }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <button
                      type="button"
                      class="btn-accordion"
                      @click="toggleSection(idx)"
                      :aria-expanded="isOpen(idx)"
                      :aria-controls="`acc-${idx}`"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="9"
                        viewBox="0 0 15 9"
                        fill="none"
                        class="transform transition-transform duration-200"
                        :class="{ '-rotate-180': isOpen(idx) }"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M14.0924 1.04999C14.5184 1.47602 14.5184 2.16674 14.0924 2.59277L8.27423 8.41095C7.8482 8.83698 7.15748 8.83698 6.73145 8.41095L0.91327 2.59277C0.487243 2.16674 0.487243 1.47602 0.91327 1.04999C1.3393 0.623963 2.03002 0.623963 2.45605 1.04999L7.50284 6.09678L12.5496 1.04999C12.9757 0.623962 13.6664 0.623962 14.0924 1.04999Z"
                          fill="#9B237B"
                        />
                      </svg>
                    </button>
                  </div>
                  <Transition name="acc">
                    <div
                      v-show="isOpen(idx)"
                      :id="`acc-${idx}`"
                      class="table-accordion w-full overflow-auto"
                    >
                      <table class="w-full min-w-[960px]">
                        <thead>
                          <tr>
                            <th
                              class="w-[10%] min-w-[92px] py-[14.5px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                            >
                              <span class="PC_Body2-R"> วันที่ร้องขอ </span>
                            </th>
                            <th
                              class="w-[5%] min-w-[54px] py-[14.5px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                            >
                              <span class="PC_Body2-R"> เวลา </span>
                            </th>
                            <th
                              class="w-[16%] py-[14.5px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                            >
                              <span class="PC_Body2-R"> ประเภทคำร้อง </span>
                            </th>
                            <th
                              class="w-[18%] py-[14.5px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                            >
                              <span class="PC_Body2-R"> ชื่อทรัพยากร </span>
                            </th>
                            <th
                              class="w-[12%] py-[14.5px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                            >
                              <span class="PC_Body2-R"> จำนวน </span>
                            </th>
                            <th
                              class="w-[24%] py-[14.5px] px-[10px] bg-[#9B237B] text-[#FFFFFF] text-left border-r-[1px] border-solid border-[#FFFFFF]"
                            >
                              <span class="PC_Body2-R">
                                ยอดที่ได้รับ/ยอดร้องขอ
                              </span>
                            </th>
                            <th
                              class="w-[15%] py-[14.5px] px-[10px] bg-[#9B237B] text-[#FFFFFF] border-l-[1px] border-solid border-[#FFFFFF]"
                            >
                              <span class="PC_Body2-R"> ชื่อผู้กระทำ </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="log in row.items"
                            :key="log.id"
                            class="bg-[#FBEFF8]"
                          >
                            <td class="p-[10px] py-[13px] !border-none">
                              <span class="PC_Body2-R text-[#1F1D1F]">
                                {{ $formatDate2(log.created_at) }}
                              </span>
                            </td>
                            <td class="p-[10px] py-[13px] !border-none">
                              <span class="PC_Body2-R text-[#1F1D1F]">
                                {{ $formatTime1(log.created_at) }}
                              </span>
                            </td>
                            <td class="p-[10px] py-[13px] !border-none">
                              <span class="PC_Body2-R text-[#1F1D1F]">
                                {{ log.type_name }}
                              </span>
                            </td>
                            <td class="p-[10px] py-[13px] !border-none">
                              <span class="PC_Body2-R text-[#1F1D1F]">
                                {{ log.name }}
                              </span>
                            </td>
                            <td class="p-[10px] py-[13px] !border-none">
                              <span class="PC_Body2-R text-[#1F1D1F]">
                                {{ $numberAndComma(log.detail.receive) }}
                              </span>
                            </td>
                            <td class="p-[10px] py-[13px] !border-none">
                              <div
                                class="flex items-center justify-between gap-[10px]"
                              >
                                <span
                                  v-if="
                                    log.detail.request != '-1.00' &&
                                    log.detail.request != '-1'
                                  "
                                  class="PC_Body2-R text-[#1F1D1F]"
                                >
                                  {{
                                    $numberAndComma(log.detail.quantity) || 0
                                  }}/{{ $numberAndComma(log.detail.request) }}
                                </span>
                                <span v-else class="PC_Body2-R text-[#1F1D1F]">
                                  {{
                                    `${
                                      $numberAndComma(log.detail.quantity) || 0
                                    }/ไม่จำกัด`
                                  }}
                                </span>
                                <div class="flex items-center gap-[10px]">
                                  <div
                                    v-if="Number(log.type) === 6"
                                    class="flex items-center justify-center py-[2px] px-[8px] rounded-[4px] border-[1px] border-solid border-[#B7B2B5] bg-[#FFF]"
                                  >
                                    <span
                                      v-if="Number(log.type) === 6"
                                      class="PC_caption-R text-[#1F1D1F]"
                                    >
                                      โอนเข้า
                                    </span>
                                    <!-- <span
                                      v-else-if="Number(log.detail?.type) === 4"
                                      class="PC_caption-R text-[#1F1D1F]"
                                    >
                                      โอนออก
                                    </span> -->
                                  </div>
                                  <ButtonComponent
                                    v-if="
                                      Number(log.type) === 4 ||
                                      Number(log.type) === 6
                                    "
                                    :icon="'InfoIcon'"
                                    :bClass="'btn_shadow--2'"
                                    @clicked="() => detail(log)"
                                  />
                                </div>
                              </div>
                            </td>
                            <td class="p-[10px] py-[13px] !border-none">
                              <span class="PC_Body2-R text-[#1F1D1F]">
                                {{ log.user_name }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Transition>
                </div>
                <div
                  v-if="productRequestHistoryList.length <= 0"
                  class="w-full flex items-center justify-center py-[20px] PC_Body1-R text-[#7C7379]"
                >
                  ขออภัย ไม่พบรายการที่ตรงกับการค้นหา
                </div>
              </div>
              <!-- accordion list -->
            </div>
            <!-- pagination for modal -->
            <PaginationComponent
              :perPageId="'perpagemodal1'"
              :items="pagination"
              @selectedPage="handlePage"
            />
            <!-- pagination for modal -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useGlobals } from "@/components/Utilities/javascripts/useGlobals";
import { useProductStore } from "@/pinia/product";
import { storeToRefs } from "pinia";
import { debounce } from "lodash";

const { $formatDate3 } = useGlobals();
const productStore = useProductStore();
const { productRequestHistoryList, allProductGroup } =
  storeToRefs(productStore);

const defaultFilter = {
  paginate: 10,
  search: "",
  start_date: "",
  end_date: "",
  group_id: 1,
};
const filter = ref({ ...defaultFilter });
const range = ref(null);
const pagination = ref(null);

const modalIsOpened = ref(false);
const emit = defineEmits(["open", "status", "detail"]);

const openModal = () => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  filter.value = { ...defaultFilter };
  openIds.value = new Set();
  getData();
};

const closeModal = () => {
  filter.value.search = "";

  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const getData = async () => {
  await productStore
    .getProductRequestHistory(filter.value)
    .then((response) => {
      if (response.status == 200) {
        pagination.value = response.data;
      }
    })
    .catch((error) => {
      if (error) {
        console.log("error", error);
      }
    });
};

const debouncedFetch = debounce(getData, 300);

const selectRange = (date) => {
  filter.value.page = "";
  range.value = date;
  if (date != null) {
    filter.value.start_date = $formatDate3(date[0]);
    filter.value.end_date = $formatDate3(date[1]);
  } else {
    filter.value.start_date = "";
    filter.value.end_date = "";
  }
  getData();
};

const handlePage = (page, perpage) => {
  filter.value.page = page;
  filter.value.paginate = perpage;
  getData();
};

const openIds = ref(new Set());

// toggle เปิด/ปิด ต่อ id
const toggleSection = (id) => {
  // ต้องสร้าง Set ใหม่เพื่อให้ Vue ตรวจจับการเปลี่ยนแปลง
  const next = new Set(openIds.value);
  next.has(id) ? next.delete(id) : next.add(id);
  openIds.value = next;
};

// helper เช็คว่า id นี้เปิดอยู่ไหม
const isOpen = (id) => openIds.value.has(id);

// // เปิดทีละอันเดียว
// const openId = ref(null);
// const toggleSection = (id) => {
//   openId.value = openId.value === id ? null : id;
// };
// const isOpen = (id) => openId.value === id;

const detail = (data) => {
  emit("detail", data);
};

defineExpose({ openModal, closeModal });
</script>

<style lang="scss" scoped>
.bodyS {
  overflow: hidden;
  color: #1f1d1f;
  text-overflow: ellipsis;

  /* Body/s */
  font-family: Kanit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; /* 150% */
  letter-spacing: 0.1px;
}
.btn-accordion {
  display: flex;
  width: 30px;
  min-width: 30px;
  min-height: 30px;
  // padding: 0 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: 6px;
  border: 1px solid #b7b2b5;
  background: #fff;
}

/* ใส่ใน <style lang="scss" scoped> ของคุณ */
.acc-enter-from,
.acc-leave-to {
  max-height: 0;
  opacity: 0;
}
.acc-enter-to,
.acc-leave-from {
  max-height: 800px; /* กำหนดสูงสุดตามเนื้อหาประมาณการ */
  opacity: 1;
}
.acc-enter-active,
.acc-leave-active {
  transition: max-height 0.25s ease, opacity 0.2s ease;
}

/* หมุนไอคอนมีใน template ผ่าน class '-rotate-180' แล้ว */
</style>
